import React, {Component} from "react";
import {Col, Row} from "antd";
import {connect} from "react-redux";
import {formatAmount} from "../../../../services/utils";
import {
  setRegistrantNumber, updateFollowUpRegistrantsCountPerMonth,
  updateRegistrantsCountPerMonth
} from "../../../../actions/actions/eventStats";


class TargetBudgetRow extends Component {

  handleInputChange = (index, value) => {
    if (isNaN(value)) return;
    const {
      updateRegistrantsCountPerMonth,
      updateFollowUpRegistrantsCountPerMonth,
      budgetManagement
    } = this.props;
    updateRegistrantsCountPerMonth(index, value, budgetManagement.appType);
    if (budgetManagement.isUpdatingSetUp) {
      updateFollowUpRegistrantsCountPerMonth(index, value);
    }
  }
  render() {
    const {
      style,
      budgetManagement,
      isRealized,
      registrantsCount,
      totalHTVA,
      index,
      MPregistrantsCount,
    } = this.props;
    const {budgetPerMonth} = budgetManagement;
    const {globalBudget} = budgetManagement;
    const {totalBudgetPerMonthPremiumMensuel} = budgetManagement;
    const currentMonth = new Date().getMonth();
    const currentYear = new Date().getFullYear();

    return (
      <Row
        className={`target-budget-row ${budgetManagement.followUp.length > 0 || budgetManagement.appType === 'all' || isRealized ? 'px-3' : 'px-3'}`}
        style={style}>

        <Col className={'flex justify-end'}
             span={budgetManagement.followUp.length === 0 && !isRealized && budgetManagement.appType !== 'monthly_premium' ? 8
               : (budgetManagement.appType === 'monthly_premium' && isRealized == false) ? 6 : 6}>
         {
            budgetManagement.isUpdatingSetUp ? (
              (budgetManagement.year == currentYear && index >= currentMonth) ? (
                <input
                  value={registrantsCount}
                  className="target-budget-input"
                  onChange={(event) => this.handleInputChange(index, event.target.value)}
                />
              ) : (budgetManagement.year > currentYear) ? (
                <input
                  value={registrantsCount}
                  className="target-budget-input"
                  onChange={(event) => this.handleInputChange(index, event.target.value)}
                />
              ) : (
                <label className="target-budget-is-saved-label">
                  {registrantsCount}
                </label>
              )
            ) : (
              <label className="target-budget-is-saved-label">
                {registrantsCount}
              </label>
            )
          }

        </Col>
        {budgetManagement.appType === 'monthly_premium' && isRealized === false &&
          <Col className={'flex justify-end'} span={5}>
            <label className="target-budget-is-saved-label">
              {MPregistrantsCount[index] ? MPregistrantsCount[index] : 0}
            </label>
          </Col>
        }
        {budgetManagement.appType === 'monthly_premium' && isRealized === false &&
          <Col className={'flex justify-end'} span={5}>
            <label className="target-budget-is-saved-label">
              {totalBudgetPerMonthPremiumMensuel.length === 0 &&
                (MPregistrantsCount.length === 0 ? registrantsCount : MPregistrantsCount[index])
              }
              {totalBudgetPerMonthPremiumMensuel.length !== 0 && registrantsCount !== '' &&
                (MPregistrantsCount.length === 0 && budgetManagement.recurrence_coefficient === 0 ?
                  parseInt(totalBudgetPerMonthPremiumMensuel[index]) :
                  parseInt(totalBudgetPerMonthPremiumMensuel[index]) + parseInt(MPregistrantsCount[index]))
              }
              {budgetManagement.appType === 'monthly_premium' && registrantsCount === '' &&
                (budgetManagement.recurrence_coefficient !== 0 ?
                    parseInt(MPregistrantsCount[index]) + parseInt(totalBudgetPerMonthPremiumMensuel[index]) :
                    (MPregistrantsCount.length === 0 && budgetManagement.recurrence_coefficient === 0 &&
                        parseInt(totalBudgetPerMonthPremiumMensuel[index])
                    )
                )
              }
            </label>
          </Col>
        }

        <Col className={'flex justify-end'}
             span={budgetManagement.followUp.length === 0 && !isRealized && budgetManagement.appType !== 'monthly_premium'
               ? 12 :
               (!isRealized && budgetManagement.appType === 'monthly_premium') ? 6
                 : 14}>
          <span className={'target-budget-label'}>
            {budgetManagement.appType === 'monthly_premium' && budgetManagement.recurrence_coefficient === 0 && registrantsCount !== '' &&
              (totalBudgetPerMonthPremiumMensuel.length === 0
                  ? formatAmount(totalHTVA, false)
                  : formatAmount(parseInt(totalBudgetPerMonthPremiumMensuel[index]) * globalBudget.pricePerUnit, false)
              )
            }
            {budgetManagement.appType === 'monthly_premium' && budgetManagement.recurrence_coefficient !== 0 && registrantsCount !== '' &&
              formatAmount((parseInt(totalBudgetPerMonthPremiumMensuel[index]) + parseInt(MPregistrantsCount[index])) * globalBudget.pricePerUnit, false)
            }
            {budgetManagement.appType !== 'monthly_premium' &&
              formatAmount(totalHTVA, false)
            }
            {(budgetManagement.appType === 'monthly_premium' && registrantsCount === '' ) &&
              (budgetManagement.recurrence_coefficient !== 0 ?
                formatAmount((parseInt(totalBudgetPerMonthPremiumMensuel[index]) + parseInt(MPregistrantsCount[index])) * globalBudget.pricePerUnit, false)
              : formatAmount(parseInt(totalBudgetPerMonthPremiumMensuel[index]) * globalBudget.pricePerUnit, false))
            }
          </span>

        </Col>
        <Col className={'flex justify-end'} span={2}>
          <div className={'target-budget-label'}>
            {!isRealized && (
              <img
                src={`/img/icons/manage-BM/BM_${budgetPerMonth[index].isPositive ? 'plus' : 'moins'}.svg`}
                className={'ml-2'}
              />
            )}
          </div>
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = state => ({
  budgetManagement: state.budgetManagement,
});

const mapDispatchToProps = {
  setRegistrantNumber,
  updateRegistrantsCountPerMonth,
  updateFollowUpRegistrantsCountPerMonth
};


export default connect(mapStateToProps, mapDispatchToProps)(TargetBudgetRow);







// WEBPACK FOOTER //
// ./app/components/Admin/EventStats/BudgetManagement/TargetBudgetRow.js